<template>
    <q-modal v-model="show_report" :content-css="{ minWidth: '100vw', minHeight: '100vh' }" no-backdrop-dismiss no-esc-dismiss>
        <q-modal-layout>
            <q-toolbar slot="header">
                <q-btn flat round dense @click="show_report = false" icon="fas fa-times" />
                <q-toolbar-title> {{ id }} - {{ title }} </q-toolbar-title>
            </q-toolbar>

            <div class="layout-padding">
                <q-tabs v-model="tab" color="secondary" class="shadow-1">
                    <q-tab slot="title" name="results" :label="$t('results')" />
                    <q-tab slot="title" name="questions" :label="$t('questions')" />

                    <q-tab-pane name="results" class="q-px-lg q-pb-xl" keep-alive>
                        <geral-results :load="tab === 'results' && show_report ? true : false" :status="status" :id="id" />
                    </q-tab-pane>

                    <q-tab-pane name="questions" class="q-px-lg q-pb-xl" keep-alive>
                        <questions :load="tab === 'questions' && show_report ? true : false" :id="id" />
                    </q-tab-pane>
                </q-tabs>
            </div>
        </q-modal-layout>
    </q-modal>
</template>

<script>
import GeralResults from 'components/admin/drills/report/GeralResults'
import Questions from 'components/admin/drills/report/Questions'

export default {
    props: ['show_report_drill', 'id', 'status', 'title'],

    components: {
        'geral-results': GeralResults,
        questions: Questions,
    },

    data() {
        return {
            tab: 'results'
        }
    },

    computed: {
        show_report: {
            get() {
                return this.show_report_drill
            },
            set() {
                this.$emit('hide_report', '')
                this.tab = 'results'
            }
        }
    }
}
</script>

<style></style>
